import useInitializePlatformAdvancedForm from './useInitializePlatformAdvancedForm'

export default useInitializePlatformAdvancedForm
